"use client";

import { Suspense } from "react";
import NavigationEvents from "@/components/common/NavigationEvents/NavigationEvents";
import BlockChat from "@/components/blocks/miewtheme/BlockChat/BlockChat";
import { Spacer, variables } from "politicamente-informados-ds";
import styled from "styled-components";
import ChatMarquees from "./MarqueesChat";


const ChatPost = (post: Record<string, unknown>) => {
  return (

    <StyledContainer>
      <Suspense>
        <NavigationEvents
          translatedURI={post?.translatedURI}
          acf={{ page_style: "light" }}
        />
      </Suspense>
      <ChatMarquees message="POLITICMAENTE INFORMADOS" />
      <div style={{ position: "absolute" }}>
        <Spacer customHeight="1rem" />
        <BlockChat />
        <Spacer customHeight="1rem" />
      </div>
    </StyledContainer>

  );
};
export default ChatPost;

const StyledContainer = styled.div`
  width: 100dvw;
  height: 100dvh;
  background-color: ${variables.colors.secondary50};
  display: grid;
  place-items: center;
  position: relative;
`;
